import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useRouteMatch } from "react-router-dom/cjs/react-router-dom.min";
import { Box, Grid, Typography, DialogActions } from "@mui/material";
import EMPButton from "../../EMPButton/EMPButton";
import EMPTabs from "../../EMPTabs/EMPTabs";
import { ModalContext } from "../ModalContext";
import chrome from "../../../../components/deliveryTools/pages/downloadTool/img/chrome.jpg";
import safari from "../../../../components/deliveryTools/pages/downloadTool/img/safari.jpg";
import edge from "../../../../components/deliveryTools/pages/downloadTool/img/edge.jpg";

const ImageWithList = ({ image, imageAlt, items, imageWidth, spacing }) => {
  const instructionItems = items.slice(0, 4).map((item) => (
    <li key={item}>
      <Typography variant="body1">{item}</Typography>
    </li>
  ));

  return (
    <Box>
      <Box sx={{ mb: spacing }}>
        <img
          src={image}
          alt={imageAlt}
          style={{
            width: imageWidth,
            display: "block",
            maxWidth: "300px",
          }}
        />
      </Box>

      <ol style={{ paddingLeft: "0px" }}>{instructionItems}</ol>
    </Box>
  );
};

ImageWithList.propTypes = {
  image: PropTypes.string.isRequired,
  imageAlt: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.string),
  imageWidth: PropTypes.string,
  spacing: PropTypes.number,
};

ImageWithList.defaultProps = {
  imageAlt: "",
  items: [],
  imageWidth: "100%",
  spacing: 3,
};

const DownloadInstructions = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);
  const { handleModal } = useContext(ModalContext);
  const { path } = useRouteMatch();

  const chromeInstructions = [
    t("DeliveryTools.downloadInstructions.tab1.list.1"),
    t("DeliveryTools.downloadInstructions.tab1.list.2"),
    t("DeliveryTools.downloadInstructions.tab1.list.3"),
  ];

  const safariInstructions = [
    t("DeliveryTools.downloadInstructions.tab2.list.1"),
    t("DeliveryTools.downloadInstructions.tab2.list.2"),
    t("DeliveryTools.downloadInstructions.tab2.list.3"),
  ];

  const edgeInstructions = [
    t("DeliveryTools.downloadInstructions.tab3.list.1"),
    t("DeliveryTools.downloadInstructions.tab3.list.2"),
    t("DeliveryTools.downloadInstructions.tab3.list.3"),
  ];

  const handleDoneClick = () => {
    handleModal(false, false);
  };

  const tabItems = [
    {
      route: `${path}`,
      title: t("DeliveryTools.downloadInstructions.tab1.title"),
      value: 0,
      content: (
        <ImageWithList
          items={chromeInstructions}
          image={chrome}
          imageAlt={t("DeliveryTools.downloadInstructions.tab1.title")}
        />
      ),
    },
    {
      route: `${path}`,
      value: 1,
      title: "Safari",
      content: (
        <ImageWithList
          items={safariInstructions}
          image={safari}
          imageAlt="Safari"
        />
      ),
    },
    {
      route: `${path}`,
      value: 2,
      title: "Microsoft Edge",
      content: (
        <ImageWithList
          items={edgeInstructions}
          image={edge}
          imageAlt="Microsoft Edge"
        />
      ),
    },
  ];

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Box mb={6}>
            <Typography variant="body1">
              {t("DeliveryTools.downloadInstructions.downloadNote")}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Box mb={6}>
            <EMPTabs
              tabItems={tabItems}
              handleChange={setActiveTab}
              activeTab={activeTab}
              onTabChange={setActiveTab}
            />
          </Box>
        </Grid>
      </Grid>

      <DialogActions sx={{ padding: "16px 0" }}>
        <Grid container justifyContent="flex-end">
          <Grid item>
            <EMPButton variant="contained" onClick={handleDoneClick}>
              {t("common.buttonCtas.done")}
            </EMPButton>
          </Grid>
        </Grid>
      </DialogActions>
    </>
  );
};

export default DownloadInstructions;
